import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const getGuestUserLinkApi= (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.USER.GET_USER_LINK,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
